import script from "./DeadlineChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DeadlineChart.vue?vue&type=script&setup=true&lang=js"

import "./DeadlineChart.vue?vue&type=style&index=0&id=cb3ab41c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb3ab41c"]])

export default __exports__